var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Credit card"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 9.25C15 9.53326 14.675 10 14.1364 10H6.86364C6.30975 10 6 9.58035 6 9.25C6 8.91527 6.30829 8.5 6.86364 8.5H14.1364C14.7113 8.5 15 8.85851 15 9.25Z",
    fill: "#787E7D",
    stroke: "#787E7D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.1667 13C12.1667 13.3639 11.9213 13.8333 11.5417 13.8333H10.2917C9.91216 13.8333 9.66675 13.4056 9.66675 13C9.66675 12.5906 9.91216 12.1667 10.2917 12.1667H11.5417C11.9213 12.1667 12.1667 12.54 12.1667 13Z",
    fill: "#787E7D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.3333 13C16.3333 13.3639 16.0878 13.8333 15.7083 13.8333H14.4583C14.0787 13.8333 13.8333 13.4056 13.8333 13C13.8333 12.5906 14.0787 12.1667 14.4583 12.1667H15.7083C16.0878 12.1667 16.3333 12.54 16.3333 13Z",
    fill: "#787E7D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.5607 17.1667H4.43948C3.18607 17.1667 2.16675 16.1114 2.16675 14.8137V6.18628C2.16675 4.88863 3.18607 3.83334 4.43948 3.83334H16.5607C17.8141 3.83334 18.8334 4.88863 18.8334 6.18628V14.8137C18.8334 16.1114 17.8141 17.1667 16.5607 17.1667ZM4.43948 5.40196C4.02167 5.40196 3.6819 5.75373 3.6819 6.18628V14.8137C3.6819 15.2463 4.02167 15.598 4.43948 15.598H16.5607C16.9785 15.598 17.3183 15.2463 17.3183 14.8137V6.18628C17.3183 5.75373 16.9785 5.40196 16.5607 5.40196H4.43948Z",
    fill: "#787E7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.72dc2726c3f095893e1d06aad827d266.svg";
export { ForwardRef as ReactComponent };